import { Rest } from "../../model"

/**
 * Retourne le reste à réaliser en dépense d'investissement de l'année
 * spécifiée en paramètre.
 * @param rests
 * @param year
 */
export function getExpenseRest(rests: Rest[], year: number): Rest {
	return getRest(rests, false, year)
}

/**
 * Retourne les restes à réaliser en dépense d'investissement des années
 * spécifiées en paramètres.
 * @param rests
 * @param years
 */
export function getExpenseRests(rests: Rest[], years: number[]): Rest[] {
	return years.map(year => getExpenseRest(rests, year))
}

/**
 * Retourne le reste à réaliser en recette d'investissement de l'année
 * spécifiée en paramètre.
 * @param rests
 * @param year
 */
export function getReceiptsRest(rests: Rest[], year: number): Rest {
	return getRest(rests, true, year)
}

/**
 * Retourne les restes à réaliser en recette d'investissement des années
 * spécifiées en paramètres.
 * @param rests
 * @param years
 */
export function getReceiptsRests(rests: Rest[], years: number[]): Rest[] {
	return years.map(year => getReceiptsRest(rests, year))
}

/**
 * Retourne le montant total du reste à réaliser de l'année spécifiée en
 * paramètre.
 * @param rests
 * @param year
 */
export function getTotalRestAmount(rests: Rest[], year: number): number {
	const receiptRest = getReceiptsRest(rests, year)
	const expenseRest = getExpenseRest(rests, year)

	return (receiptRest ? receiptRest.amount : 0)
	+ (expenseRest ? expenseRest.amount : 0)
}

/**
 * Retourne le reste à réaliser de l'année spécifiée en paramètre, soit en
 * recette d'investissement (receipts == true), soit en dépense
 * d'investissement (receipts == false).
 * @param rests
 * @param receipts
 * @param year
 */
function getRest(
	rests   : Rest[],
	receipts: boolean,
	year    : number
): Rest {
	return rests.find(rest => year === rest.year && receipts === rest.receipt)
}


// WEBPACK FOOTER //
// ./src/domain/sfp/rest-domain.ts